import { adminSupabase } from '@/lib/supabase';

export type JumpstartSignupStatus = 'pending' | 'paid' | 'provisioned' | 'failed';

export interface JumpstartPendingSignup {
  id: string;
  created_at: string;
  business_name: string | null;
  email: string;
  plan_slug: string | null;
  status: JumpstartSignupStatus;
  paid_at: string | null;
  sumit_transaction_id: string | null;
  sumit_document_number: string | null;
  sumit_document_url?: string | null;
  jumpstart_org_id: string | null;
  error_message: string | null;
}

export const jumpstartSignupsApi = {
  listRecent: async (): Promise<JumpstartPendingSignup[]> => {
    const { data, error } = await adminSupabase
      .from('jumpstart_pending_signups')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(50);

    if (error) throw error;
    return (data ?? []) as JumpstartPendingSignup[];
  },
};
